import { render, staticRenderFns } from "./JSelectMaterialModal.vue?vue&type=template&id=94667c44&scoped=true"
import script from "./JSelectMaterialModal.vue?vue&type=script&lang=js"
export * from "./JSelectMaterialModal.vue?vue&type=script&lang=js"
import style0 from "./JSelectMaterialModal.vue?vue&type=style&index=0&id=94667c44&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94667c44",
  null
  
)

export default component.exports